import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router';

import { Button } from 'twyne-new.ui'

import { useAppLayoutContext } from '@/components/app-layout/context';
import { useAppAlert } from '@Components/AppAlert';
import FormWrapper from '@Components/form/Wrapper';
import history from 'utils/history';

import FormComponent from '../components/Form';
import FieldsFormComponent from '../components/fields';
import { FormProvider, useFormStore } from '../store';

function EditDetailsButton({ data, slugs, onSubmit }) {
  const [open, setOpen] = useState(false)

  const EditButton = <Button color='accent' onClick={() => setOpen(true)}>Edit Details</Button>

  return <>
    {!open ? EditButton : <FormComponent
      trigger={EditButton}
      data={data}
      handleSubmit={onSubmit}
      slugs={slugs}
      onCancel={() => setOpen(false)}
    />}
  </>
}

function FormFields({ data, onSubmit, slugs }) {
  const { setMenuCollapsed } = useAppLayoutContext()
  setMenuCollapsed(true)

  return <>
    <FormWrapper title='Form'>
      <FieldsFormComponent data={data} handleSubmit={onSubmit} >
        <EditDetailsButton data={data} onSubmit={onSubmit} slugs={slugs} />
      </FieldsFormComponent>
    </FormWrapper>
  </>
}

function Form({ builder, match: { params: { id } } }) {
  const { collection: { useLoad, useSubmit, item }, lists: { forms: { useLoad: useLoadForms, items } } } = useFormStore()
  const { handleSuccess, handleError } = useAppAlert()
  const [slugs, setSlugs] = useState([])

  useLoadForms()
  const loadForm = useLoad(id)
  const handleSubmit = useSubmit()

  const loadData = useCallback(async items => {
    const defaultSlugs = ['form1', 'form2', 'form3']
    const allSlugs = items.map(form => form.slug)

    if (id && item?.slug) {
      defaultSlugs.push(item.slug)
    }

    const slugs = allSlugs.filter(slug => !defaultSlugs.includes(slug))
    setSlugs(slugs)
  }, [id, item])

  useEffect(() => {
    if (items.length) {
      loadData(items)
    }
  }, [loadData, items])

  async function handleSubmitAndRedirect(payload) {
    try {
      const { id } = await handleSubmit(payload)
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Form ${message}.`)
      await loadForm()
      if (!payload.id) {
        history.push(`/offer/forms/${id}/fields`);
      } else {
        history.push(`/offer/forms/${payload.id}/fields`);
      }
    } catch {
      handleError('Error', 'Form was not saved.');
    }
  }

  if (!item) return null

  if (builder) {
    return <FormFields data={item} onSubmit={handleSubmitAndRedirect} slugs={slugs} />
  }

  return <FormComponent data={item} handleSubmit={handleSubmitAndRedirect} slugs={slugs} />
}

Form.propTypes = {
  builder: PropTypes.bool,
  match: PropTypes.object,
};

Form.defaultProps = {
  builder: false,
}

const FormRouter = withRouter(Form);

export default function FormLayout(props) {
  return <FormProvider>
    <FormRouter {...props} />
  </FormProvider>
}
